import { atom, useAtom, useSetAtom } from 'jotai'

export const membershipPlansStateAtom = atom({
  /**
   * Growth event: new member discount
   */
  claimedNewMemberDiscount: false,
})
export const useMembershipPlansStatePageContextAtom = () =>
  useAtom(membershipPlansStateAtom)
export const useMembershipPlansStateWriteOnlyAtom = () =>
  useSetAtom(membershipPlansStateAtom)
